const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};
export const validatePhoneNumber = (number) => {
  // 10자리: 031-111-1111 (3-3-4)
  // 11자리: 010-1111-1111 (3-4-4)
  const re = /^(\d{3}-\d{3}-\d{4}|\d{3}-\d{4}-\d{4})$/;
  return re.test(number);
};
export const formValidation = (formData) => {
  let newErrors = {};

  // Check if any field is empty
  Object.keys(formData).forEach((field) => {
    if (formData[field].trim() === "" && field !== "content") {
      newErrors[field] = "필수 항목입니다."; // Set error message for empty fields
    }
  });

  // Check email field for proper format
  if (formData.email && !validateEmail(formData.email)) {
    newErrors.email = "이메일 형식이 올바르지 않습니다.";
  }

  // Check phone number field for proper format
  if (formData.phoneNumber && !validatePhoneNumber(formData.phoneNumber)) {
    newErrors.phoneNumber = "연락처 형식이 올바르지 않습니다.";
  }

  // Return the new errors object
  return newErrors;
};

export const quoteFormValidation = (formData) => {
  let newErrors = {};

  // Validate company name, representative name
  ["companyName", "representative"].forEach((field) => {
    if (!formData[field] || formData[field].trim() === "") {
      newErrors[field] = "필수 항목입니다."; // Set error message for empty fields
    }
  });

  // Check email field for proper format
  if (!formData.email || !validateEmail(formData.email)) {
    newErrors.email = "이메일 형식이 올바르지 않습니다.";
  }

  // Check phone number field for proper format
  if (!formData.phoneNumber || !validatePhoneNumber(formData.phoneNumber)) {
    newErrors.phoneNumber = "연락처 형식이 올바르지 않습니다.";
  }

  // Validate each product entry
  formData.products.forEach((product, index) => {
    // Ensure product ID is not empty
    if (!product.id || product.id.trim() === "") {
      newErrors[`product_${index}_id`] = "제품 ID는 필수 항목입니다.";
    }

    // Check if amount is a valid number and greater than 0
    if (
      !product.amount ||
      isNaN(product.amount) ||
      Number(product.amount) <= 0
    ) {
      newErrors[`product_${index}_amount`] = "유효한 수량을 입력해주세요.";
    }
  });

  // Return the new errors object
  return newErrors;
};

export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  
  if (phoneNumberLength < 4) return phoneNumber;
  
  // 첫 3자리가 010, 011, 016, 017, 018, 019로 시작하면 11자리 (휴대폰)
  // 그 외는 10자리 (일반 전화번호)
  const isMobile = /^01[0-9]/.test(phoneNumber);
  
  // 3자리까지는 그대로
  if (phoneNumberLength < 4) return phoneNumber;
  
  // 4-6자리: 031-1 형식
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  
  // 7-9자리: 입력 중
  if (phoneNumberLength < 10) {
    if (isMobile) {
      // 모바일: 010-1111-1 형식 (3-4-나머지)
      if (phoneNumberLength >= 8) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
          3,
          7
        )}-${phoneNumber.slice(7)}`;
      }
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    } else {
      // 일반 전화: 031-111-1 형식 (3-3-나머지)
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6)}`;
    }
  }
  
  // 10자리: 031-111-1111 (3-3-4)
  if (phoneNumberLength === 10) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  
  // 11자리: 010-1111-1111 (3-4-4)
  if (phoneNumberLength >= 11) {
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    7
  )}-${phoneNumber.slice(7, 11)}`;
  }
  
  return phoneNumber;
};
